
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2071.35-1762.176h4.719v-6.034a.57.57 0 00-.609-.609h-3.504a.6.6 0 00-.44.165.592.592 0 00-.17.444zm-3.23.758h11.118a1.809 1.809 0 001.323-.461 1.735 1.735 0 00.47-1.3v-9.089l-1.2-.827v9.613a.885.885 0 01-.213.644.846.846 0 01-.631.218h-10.615a.849.849 0 01-.627-.218.874.874 0 01-.218-.644v-9.6l-1.2.818v9.09a1.735 1.735 0 00.47 1.3 1.809 1.809 0 001.322.455zm-4.11-9.152a.579.579 0 00.174.409.619.619 0 00.47.183.573.573 0 00.287-.074 1.592 1.592 0 00.235-.161l8.237-6.9a.436.436 0 01.292-.126.474.474 0 01.318.126l8.2 6.9a2.86 2.86 0 00.253.161.573.573 0 00.287.074.671.671 0 00.444-.152.52.52 0 00.183-.422.644.644 0 00-.235-.514l-8.499-7.14a1.416 1.416 0 00-.94-.374 1.481 1.481 0 00-.958.374l-8.5 7.14a.611.611 0 00-.248.496zm15.08-3.544l1.942 1.646v-3.8a.511.511 0 00-.549-.549h-.836a.556.556 0 00-.4.148.533.533 0 00-.152.4z"}})])])
          )
        }
      }
    